import LifecareStudio from '../../../components/demand-studio/LifecareStudio';

const LifecareStudioPage = () => {
    return <LifecareStudio />;
};

export default LifecareStudioPage;
